import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import { Const } from '../const';

import { environment } from '../../environments/environment';

import { SystemRestPlanDashboard } from '../servicer/models/system-rest-plan-dashboard';

import { SystemRestPlanServiceProvider } from '../servicer/system-rest-plan-service';

/**
 * 休憩計画 ダッシュボードを定期間隔で取得するプロバイダー.
 */
@Injectable()
export class SystemRestPlanDashboardIntervalReceiverProvider {
  /** ダッシュボードの空のレスポンス. */
  private readonly dashboardEmptyResponse = null;

  /** ダッシュボード情報. */
  private cache: BehaviorSubject<SystemRestPlanDashboard> = new BehaviorSubject<SystemRestPlanDashboard>(this.dashboardEmptyResponse);

  /** インターバルのSubscription. */
  private intervalSubscription: any = null;

  /** 実行中. */
  private processing = false;

  constructor(
    public systemDashboardService: SystemRestPlanServiceProvider
  ) { }

  /**
   * 開始.
   */
  start() {
    this.execute();
    // 重複してintervalを起動しない
    if (!this.intervalSubscription) {
      this.intervalSubscription = Observable.interval(environment.systemRestPlanDashboardInterval).subscribe(() => this.execute());
    }
  }

  /**
   * 実行します.
   */
  execute() {
    of(this.processing)
      .filter((processing) => !processing)
      .pipe(tap(() => this.processing = true))
      .flatMap(() => this.get())
      .pipe(tap(() => this.processing = false))
      .subscribe();
  }

  /**
   * 停止.
   */
  stop() {
    this.cache.next(this.dashboardEmptyResponse);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      //clearInterval(this.intervalSubscription);
      this.intervalSubscription = null;
    }
  }

  /**
   * ダッシューボードを取得します.
   */
  getDashboard(): Observable<SystemRestPlanDashboard> {
    return this.cache.asObservable().filter((data) => data !== null);
  }

  /**
   * ダッシュボード表示情報を取得します.
   * 定期的に呼び出されるため、エラーが発生しても、何も処理をしません.
   */
  private get(): Observable<SystemRestPlanDashboard> {
    return this.systemDashboardService.getDashboard()
      .map((response) => {
        if (response.result === Const.ResponseResult.SUCCESS) {
          this.cache.next(response.item);
          return response.item;
        }

        return this.cache.value;
      })
      .catch((error) => {
        console.error(error);
        return Observable.of(this.cache.value);
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/system-rest-plan-dashboard-interval-receiver/system-rest-plan-dashboard-interval-receiver.ts